/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBorderCorners = createReactComponent("border-corners", "IconBorderCorners", [
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "svg-0" }],
  ["path", { d: "M20 16v2a2 2 0 0 1 -2 2h-2", key: "svg-1" }],
  ["path", { d: "M8 20h-2a2 2 0 0 1 -2 -2v-2", key: "svg-2" }],
  ["path", { d: "M4 8v-2a2 2 0 0 1 2 -2h2", key: "svg-3" }]
]);

export { IconBorderCorners as default };
//# sourceMappingURL=IconBorderCorners.js.map
